// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".shop-page-loader{position:fixed;top:50%}.menu-icon-subtext-local{left:-13px;bottom:-13px}.v-menu__content{margin-left:15px!important}.v-treeview--dense .v-treeview-node__root{min-height:0}.v-treeview-node--click>.v-treeview-node__root,.v-treeview-node--click>.v-treeview-node__root>.v-treeview-node__content>*{white-space:normal!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
